import { useLabelVersion } from '../features/labels/LabelsProvider';
import { labelId, labelRegion, labelArea } from '../features/labels/labels';
// import React, {useState} from 'react'
// import { Button, Grid, Modal, Avatar, IconButton, Box, Typography, Tooltip } from '@mui/material';
// import { EliminarCentro } from '../utils/apiServer';
// import DeleteIcon from '@mui/icons-material/Delete';
// import BusinessIcon from '@mui/icons-material/Business';

// import EditIcon from '@mui/icons-material/Edit';
// import EditOffIcon from '@mui/icons-material/EditOff';

// function capitalize(value) {
//   // Divide la cadena en palabras
//   let words = value.toLowerCase().split(' ');

//   // Capitaliza la primera letra de cada palabra
//   let capitalizedWords = words.map(word => {
//       // Capitaliza la primera letra de la palabra
//       let capitalized = word.charAt(0).toUpperCase() + word.slice(1);
//       return capitalized;
//   });

//   // Une las palabras nuevamente en una cadena
//   let capitalized = capitalizedWords.join(' ');

//   // Si la cadena comienza con 'De', agrega un espacio después de 'De'
//   if (capitalized.startsWith('Los')) {
//       capitalized = capitalized.replace('Los', 'Los ');
//   }

//   // Si la cadena comienza con 'Puerto', agrega un espacio después de 'Puerto'
//   if (capitalized.startsWith('Puerto')) {
//       capitalized = capitalized.replace('Puerto', 'Puerto ');
//   }

//   return capitalized;
// }


// const Centro = ({ centros, actualizarListaCentros, centroSeleccionado , setCentroSeleccionado, handleEdit, editar, cancelEdit ,translate, token, servidor}) => {

//   const [openModal, setOpenModal] = useState(false); // si se decea eliminar usuario
//   const [fechasServicio, setFechasServicio] = useState({ inicio: '', fin: '' });
//   const servicios = ['nanoox', 'enviro', 'pss', 'scapp'];

//   // //console.log(fechasServicio,'fechasServicio')

//   const handleCentroClick = (centro) => {
//     // console.log('centro',centro)
//     setCentroSeleccionado(centro.centro_id);
//     for (const servicio of servicios) {
//       if (centro[servicio].status) {
//         setFechasServicio({ inicio: centro[servicio].init, fin: centro[servicio].fin });
//         return;
//       }
//     }
//     setFechasServicio({ inicio: '', fin: '' });
//   };

//     // Función para abrir el modal de confirmación de eliminación
//     const handleOpenModal = () => {
//       setOpenModal(true);
//     };
//     const handleCloseModal = () => {
//       setOpenModal(false);
//     };

//   // //console.log('centroselecionado', centroSeleccionado)
//   const procesarCentros = (centros) => {
//     const regiones = {};
  
//     centros.forEach((centro) => {
//       if (centro.centro_id && typeof centro.centro_id === 'string') {
//         const [nombreCentro, area, region] = centro.centro_id.split('-');
        
//         if (!regiones[region]) {
//           regiones[region] = {};
//         }
    
//         if (!regiones[region][area]) {
//           regiones[region][area] = [];
//         }
    
//         regiones[region][area].push({
//           nombreCentro,
//           ...centro
//         });
//       } else {
//         console.warn(`Centro con ID inválido o indefinido encontrado:`, centro);
//       }
//     });
  
//     return regiones;
//   };

//   const regiones = procesarCentros(centros);


//   const handleDelete = () => {
//     // Verificar si hay un centro seleccionado antes de eliminarlo
//     if (centroSeleccionado) {
//       //console.log("Usuario seleccionado:", centroSeleccionado);
//       // Llamar a la función para eliminar el centro seleccionado
//       EliminarCentro( centroSeleccionado, servidor, token)
//         .then(async () => {
//           // Opcionalmente, puedes actualizar la lista de centro aquí si es necesario
//           // Actualiza la lista de centro después de eliminar el centro
//           await actualizarListaCentros();
//           setOpenModal(false);
//         })
//         .catch((error) => {
//           // Manejar cualquier error que ocurra durante la eliminación del centro
//           console.error("Error al eliminar usuario:", error);
//           // Opcionalmente, puedes mostrar un mensaje de error al centro
//         });
//     } else {
//       console.warn("No se ha seleccionado ningún usuario para eliminar.");
//       // Opcionalmente, puedes mostrar un mensaje al centro indicando que no ha seleccionado ningún centro
//       setOpenModal(false);
//     }
//   };
  
  
//   const generarColorAvatar = (centro) => {
//     // Generar un valor hash a partir del nombre de usuario
//     let hash = 0;
//     for (let i = 0; i < centro.length; i++) {
//       hash = centro.charCodeAt(i) + ((hash << 5) - hash);
//     }
//     // Convertir el hash a un color hexadecimal
//     const color = (hash & 0x00FFFFFF).toString(16).toUpperCase();
//     // Añadir ceros a la izquierda si es necesario
//     return "#" + "00000".substring(0, 6 - color.length) + color;
//   };

//   const handleEditClick = (centro) => {
//     handleEdit(centro);
//   };

//   const ordenar = (obj) =>
//     Object.keys(obj)
//       .sort()
//       .reduce((acc, key) => {
//         acc[key] = obj[key];
//         return acc;
//       }, {});

//   const regionesOrd = ordenar(regiones);


//   return (

//     <Grid container sx={{ width: '100%', flexWrap: 'wrap', gap:'0.5vw', overflowY:'auto', marginTop:'1vh' }}>
//       {Object.entries(regionesOrd).map(([region, areas]) => {
//         const areasOrd = ordenar(areas);

//         return (
//           <Grid
//             item
//             xs={3.9}
//             key={region}
//             sx={{
//               display: 'flex',
//               flexDirection: 'column',
//               border: '0.01vw solid #e94e1a',
//               borderRadius: '0.5vw',
//               p: '0.5vw',
//               minWidth: '20vw', // asegura que no se encoja demasiado
//               boxSizing: 'border-box'
//             }}
//           >
//             {/* Región */}
//             <Typography variant="h5" sx={{ mb: '1vh', textAlign: 'center', color:'#c3c3c3', fontSize:'1.2vw' }}>
//               {capitalize(region)}
//             </Typography>

//             {/* Áreas */}
//             {Object.entries(areasOrd).map(([area, centros]) => (
//               <Box key={area} sx={{ mb: '.5vh' }}>
//                 <Typography variant="h6" sx={{ display: 'inline', mr: '0.5vw', color:'#a0a0a0', fontSize:'1vw' }}>
//                   {capitalize(area)}:
//                 </Typography>

//                 {/* Centros */}
//                 {centros.map((centro, index) => {
//                   const sel = centroSeleccionado === centro.centro_id;

//                   // Función auxiliar para obtener coordenadas seguras
//                   const getCoordinates = (gps) => {
//                     if (!gps) return { lat: '--', lon: '--' };

//                     const source = gps.active === 'manual' ? gps.manual : gps.auto;
//                     return {
//                       lat: source?.lat ?? '--',
//                       lon: source?.lon ?? '--',
//                       timestamp: source?.timestamp ?? '--',
//                     };
//                   };

//                   // Dentro de tu componente:
//                   const coords = getCoordinates(centro.gps_coordinates);
//                   return (
//                     <span key={centro.centro_id} style={{fontSize:'0.5vw'}}>
//                       <Tooltip
//                         placement="top"
//                         arrow
//                         title={
//                           <Box sx={{ p: '.5vw', backgroundColor:'#1e1e1e' }}>
//                             <Typography variant="subtitle2" style={{ color:'#c3c3c3', fontSize:'0.8vw'}}>
//                               {capitalize(centro.nombreCentro)}
//                             </Typography>
//                             {fechasServicio.inicio && fechasServicio.fin && (
//                               <>
//                                 <Typography variant="caption">
//                                   {translate('inicio')}: {fechasServicio.inicio}
//                                 </Typography>
//                                 <Typography variant="caption" display="block">
//                                   {translate('fin')}: {fechasServicio.fin}
//                                 </Typography>
//                               </>
//                             )}
//                             {/* Coordenadas y especie */}
//                             <Typography variant="caption" display="block">
//                               Latitud: {coords.lat}
//                             </Typography>
//                             <Typography variant="caption" display="block">
//                               Longitud: {coords.lon}
//                             </Typography>
//                             <Typography variant="caption" display="block">
//                               Especie: {centro.cicle_info?.specie || '--'}
//                             </Typography>
//                             <Box sx={{ mt: 1, display: 'flex', gap: 1 }}>
//                               <IconButton size="small" onClick={() => handleEditClick(centro)}>
//                                 {editar ? <EditOffIcon fontSize="1vw" /> : <EditIcon fontSize="1vw" />}
//                               </IconButton>
//                               <IconButton
//                                 size="small"
//                                 onClick={handleOpenModal}
//                               >
//                                 <DeleteIcon fontSize="1vw" />
//                               </IconButton>
//                             </Box>
//                           </Box>
//                         }
//                         slotProps={{
//                           popper: {
//                             sx: {
//                               "& .MuiTooltip-tooltip": {
//                                 backgroundColor: "#1e1e1e",   // color de fondo
//                                 color: "#c3c3c3",             // color del texto
//                                 fontSize: "0.9vw",            // tamaño de fuente
//                                 border: "0.01vw solid #e94e1a"   // borde opcional
//                               },
//                               "& .MuiTooltip-arrow": {
//                                 color: "#1e1e1e"   ,           // color de la flechita
//                                   "&:before": {
//                                     border: "0.01vw solid #e94e1a",  // 👈 borde igual al cuadro
//                                     boxSizing: "border-box"
//                                   }
//                               }
//                             }
//                           }
//                         }}
//                       >
//                         <span onMouseEnter={() => handleCentroClick(centro)} style={{ cursor: 'pointer', fontWeight: sel ? 'bold' : 'normal',  color: sel ? '#e84e0e' : '#707070', fontSize:'0.8vw' }}>
//                           {capitalize(centro.nombreCentro)}
//                         </span>
//                       </Tooltip>
//                       {index < centros.length - 1 && ' - '}
//                     </span>
//                   );
//                 })}
//               </Box>
//             ))}
//           </Grid>
//         );
//       })}

//        {/* Modal de confirmación de eliminación */}
//        <Modal open={openModal} >
//          <Grid  container justifyContent='center' style={{ height:'11vh', width:'22vw', borderRadius:'2vh', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: '#1e1e1e',  }}>
//            <h1 variant="h6" style={{fontSize:'1vw', marginTop:'1.5vh', marginBottom:'-.5vh'}}>{translate('confirm_delete_center')}</h1>
//            <Grid container justifyContent='center'>
//              <Grid item> 
//                <Button style={{border:'solid 0.01vw',minWidth:'5vw',maxWidth:'5vw', minHeight:'4vh',maxHeight:'4vh', fontSize:'.9vw'}} variant='outlined' color='inherit' onClick={() => {
//                 // Aquí puedes implementar la lógica para eliminar el usuario
//                 //console.log("centro eliminado:", centroSeleccionado);
//                 handleDelete();
//               }}>{translate('si')}</Button>
//             </Grid>
//             <Grid item>
//               <Button style={{border:'solid 0.01vw', marginLeft:'.5vw',minWidth:'5vw',maxWidth:'5vw', minHeight:'4vh',maxHeight:'4vh', fontSize:'.9vw'}} variant='outlined' color='inherit' onClick={handleCloseModal}>{translate('no')}</Button>
//             </Grid>
//           </Grid>
//         </Grid>
//       </Modal>
//     </Grid>
//   )
// }

// export default Centro
import React, { useMemo, useState } from 'react';
import {
  Button,
  Grid,
  Modal,
  IconButton,
  Box,
  Typography,
  Tooltip,
  Chip,
  Divider,
  Stack
} from '@mui/material';
import { EliminarCentro } from '../utils/apiServer';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import EditOffIcon from '@mui/icons-material/EditOff';
import BusinessIcon from '@mui/icons-material/Business';
import PlaceIcon from '@mui/icons-material/Place';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';

function capitalize(value = '') {
  const words = value.toLowerCase().split(' ');
  let capitalized = words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  if (capitalized.startsWith('Los')) {
    capitalized = capitalized.replace('Los', 'Los ');
  }

  if (capitalized.startsWith('Puerto')) {
    capitalized = capitalized.replace('Puerto', 'Puerto ');
  }

  return capitalized;
}

const serviciosConfig = [
  { key: 'nanoox', label: 'NANOOX' },
  { key: 'enviro', label: 'ENVIRO' },
  { key: 'pss', label: 'PSS' },
  { key: 'scapp', label: 'SCAPP' },
  { key: 'flux', label: 'FLUX' },
];

const glassCard = {
  // background: 'linear-gradient(135deg, rgba(9,18,36,0.96), rgba(17,10,24,0.92))',
  background: 'radial-gradient(circle at top right, rgba(233, 78, 26, 0.08), transparent 26%), linear-gradient(180deg, rgba(15, 23, 38, 0.96), rgba(8, 14, 24, 0.96))',
  border: '1px solid rgba(233,78,26,0.28)',
  boxShadow: '0 0 18px rgba(233,78,26,0.06)',
  borderRadius: '18px',
};

const sectionTitle = {
  color: '#f5f7fa',
  fontWeight: 700,
  letterSpacing: '.02em',
};

const sectionLabel = {
  color: '#e94e1a',
  fontSize: '.72rem',
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '.12em',
};

const infoText = {
  color: '#aeb7c4',
  fontSize: '.88rem',
};

const Centro = ({
  centros,
  actualizarListaCentros,
  centroSeleccionado,
  setCentroSeleccionado,
  handleEdit,
  editar,
  cancelEdit,
  translate,
  token,
  servidor
}) => {
  useLabelVersion();
  const [openModal, setOpenModal] = useState(false);

  // console.log('centros',centros)

  const procesarCentros = (centros) => {
    const regiones = {};

    centros.forEach((centro) => {
      if (centro.centro_id && typeof centro.centro_id === 'string') {
        const [nombreCentro, area, region] = centro.centro_id.split('-');

        if (!regiones[region]) regiones[region] = {};
        if (!regiones[region][area]) regiones[region][area] = [];

        regiones[region][area].push({
          nombreCentro,
          ...centro
        });
      } else {
        console.warn('Centro con ID inválido o indefinido encontrado:', centro);
      }
    });

    return regiones;
  };

  const ordenar = (obj) =>
    Object.keys(obj)
      .sort()
      .reduce((acc, key) => {
        acc[key] = obj[key];
        return acc;
      }, {});

  const regionesOrd = useMemo(() => {
    const regiones = procesarCentros(centros);
    const regionesOrdenadas = ordenar(regiones);

    Object.keys(regionesOrdenadas).forEach(region => {
      regionesOrdenadas[region] = ordenar(regionesOrdenadas[region]);
    });

    return regionesOrdenadas;
  }, [centros]);

  const centroActivo = useMemo(
    () => centros.find(c => c.centro_id === centroSeleccionado) || null,
    [centros, centroSeleccionado]
  );

  const getCoordinates = (gps) => {
    if (!gps) {
      return { lat: '--', lon: '--', mode: '--', timestamp: '--' };
    }

    const isManual = gps.active === 'manual';
    const source = isManual ? gps.manual : gps.auto;

    return {
      lat: source?.lat ?? '--',
      lon: source?.lon ?? '--',
      timestamp: source?.timestamp ?? '--',
      mode: isManual ? 'Manual' : 'Auto',
    };
  };

  const getCentroDates = (centro) => {
    for (const servicio of serviciosConfig) {
      if (centro?.[servicio.key]?.status) {
        return {
          inicio: centro[servicio.key]?.init || '--',
          fin: centro[servicio.key]?.fin || '--',
        };
      }
    }

    return { inicio: '--', fin: '--' };
  };

  const getServiciosActivos = (centro) => {
    return serviciosConfig.filter(servicio => centro?.[servicio.key]?.status);
  };

  const handleCentroClick = (centro) => {
    setCentroSeleccionado(centro.centro_id);
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleDelete = () => {
    if (!centroSeleccionado) {
      console.warn('No se ha seleccionado ningún centro para eliminar.');
      setOpenModal(false);
      return;
    }

    EliminarCentro(centroSeleccionado, servidor, token)
      .then(async () => {
        await actualizarListaCentros();
        setOpenModal(false);
      })
      .catch((error) => {
        console.error('Error al eliminar centro:', error);
      });
  };

  const centroCoords = getCoordinates(centroActivo?.gps_coordinates);
  const centroDates = getCentroDates(centroActivo);
  const serviciosActivos = getServiciosActivos(centroActivo);

  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{
          width: '100%',
          mt: '1vh',
          alignItems: 'stretch',
        }}
      >
        {/* PANEL IZQUIERDO: REGIONES / ÁREAS / CENTROS */}
        <Grid item xs={12} lg={8}>
          <Box
            sx={{
              ...glassCard,
              p: 2,
              height: '100%',
              minHeight: '52vh',
            }}
          >
            <Box sx={{ mb: 2 }}>
              <Typography sx={sectionLabel}>Registro actual</Typography>
              <Typography sx={{ ...sectionTitle, fontSize: '1.45rem', mt: .3 }}>
                Centros y barcos creados
              </Typography>
              <Typography sx={{ ...infoText, mt: .4 }}>
                Selecciona un centro para ver su detalle operativo, editarlo o eliminarlo.
              </Typography>
            </Box>

            <Box
              sx={{
                maxHeight: '58vh',
                overflowY: 'auto',
                pr: 1,
                '&::-webkit-scrollbar': {
                  width: '8px',
                },
                '&::-webkit-scrollbar-track': {
                  background: 'rgba(255,255,255,0.03)',
                  borderRadius: '10px',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: 'rgba(233,78,26,0.55)',
                  borderRadius: '10px',
                },
              }}
            >
              <Grid container spacing={2}>
                {Object.entries(regionesOrd).map(([region, areas]) => {
                  const totalCentros = Object.values(areas).flat().length;

                  return (
                    <Grid item xs={12} md={6} key={region}>
                      <Box
                        sx={{
                          ...glassCard,
                          p: 1.8,
                          minHeight: '100%',
                          // background:
                            // 'linear-gradient(180deg, rgba(7,16,31,0.96), rgba(8,10,20,0.98))',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            mb: 1.4,
                          }}
                        >
                          <Box>
                            <Typography
                              sx={{
                                color: '#f4f6fb',
                                fontSize: '1rem',
                                fontWeight: 700,
                              }}
                            >
                              {labelRegion(region, capitalize(region))}
                            </Typography>
                            <Typography
                              sx={{
                                color: '#8f99a8',
                                fontSize: '.78rem',
                              }}
                            >
                              {totalCentros} {totalCentros === 1 ? 'registro' : 'registros'}
                            </Typography>
                          </Box>

                          <Chip
                            label={labelRegion(region, capitalize(region))}
                            size="small"
                            sx={{
                              color: '#ff8a5b',
                              border: '1px solid rgba(233,78,26,0.35)',
                              backgroundColor: 'rgba(233,78,26,0.08)',
                              fontWeight: 700,
                            }}
                          />
                        </Box>

                        <Stack spacing={1.5}>
                          {Object.entries(areas).map(([area, centrosArea]) => (
                            <Box key={area}>
                              <Typography
                                sx={{
                                  color: '#e94e1a',
                                  fontSize: '.75rem',
                                  fontWeight: 700,
                                  textTransform: 'uppercase',
                                  mb: .8,
                                  letterSpacing: '.08em',
                                }}
                              >
                                {labelArea({ region, area }, capitalize(area))}
                              </Typography>

                              <Box
                                sx={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  gap: .9,
                                }}
                              >
                                {centrosArea.map((centro) => {
                                  const sel = centroSeleccionado === centro.centro_id;
                                  const activos = getServiciosActivos(centro);

                                  return (
                                    <Tooltip
                                      key={centro.centro_id}
                                      arrow
                                      placement="top"
                                      title={
                                        <Box sx={{ p: .6 }}>
                                          <Typography
                                            sx={{
                                              color: '#fff',
                                              fontSize: '.86rem',
                                              fontWeight: 700,
                                              mb: .5,
                                            }}
                                          >
                                            {labelId(centro.centro_id, 'car', capitalize(centro.nombreCentro))}
                                          </Typography>
                                          <Typography sx={{ color: '#c7cfda', fontSize: '.76rem' }}>
                                            Especie: {centro.cicle_info?.specie || '--'}
                                          </Typography>
                                          <Typography sx={{ color: '#c7cfda', fontSize: '.76rem' }}>
                                            Servicios activos: {activos.length || 0}
                                          </Typography>
                                        </Box>
                                      }
                                      slotProps={{
                                        popper: {
                                          sx: {
                                            '& .MuiTooltip-tooltip': {
                                              backgroundColor: '#0e1524',
                                              color: '#fff',
                                              border: '1px solid rgba(233,78,26,0.35)',
                                              borderRadius: '12px',
                                            },
                                            '& .MuiTooltip-arrow': {
                                              color: '#0e1524',
                                            },
                                          },
                                        },
                                      }}
                                    >
                                      <Box
                                        onClick={() => handleCentroClick(centro)}
                                        sx={{
                                          px: 1.2,
                                          py: .95,
                                          borderRadius: '14px',
                                          border: '1px solid',
                                          borderColor: sel
                                            ? '#e94e1a'
                                            : 'rgba(233,78,26,0.22)',
                                          background: sel
                                            ? 'linear-gradient(135deg, rgba(233,78,26,0.18), rgba(10,16,30,0.92))'
                                            : 'rgba(255,255,255,0.02)',
                                          color: sel ? '#fff' : '#b7c0cb',
                                          cursor: 'pointer',
                                          transition: 'all .22s ease',
                                          minWidth: '150px',
                                          '&:hover': {
                                            transform: 'translateY(-2px)',
                                            borderColor: '#e94e1a',
                                            color: '#fff',
                                            boxShadow: '0 0 14px rgba(233,78,26,0.14)',
                                          },
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: .8,
                                          }}
                                        >
                                          <BusinessIcon sx={{ fontSize: '1rem', color: sel ? '#ff8a5b' : '#7f8a97' }} />
                                          <Typography
                                            sx={{
                                              fontSize: '.9rem',
                                              fontWeight: sel ? 700 : 500,
                                              lineHeight: 1.2,
                                            }}
                                          >
                                            {labelId(centro.centro_id, 'car', capitalize(centro.nombreCentro))}
                                          </Typography>
                                        </Box>

                                        {activos.length > 0 && (
                                          <Box
                                            sx={{
                                              display: 'flex',
                                              flexWrap: 'wrap',
                                              gap: .5,
                                              mt: .9,
                                            }}
                                          >
                                            {activos.slice(0, 2).map(servicio => (
                                              <Chip
                                                key={servicio.key}
                                                label={servicio.label}
                                                size="small"
                                                sx={{
                                                  height: 22,
                                                  color: '#ffb08f',
                                                  border: '1px solid rgba(233,78,26,0.25)',
                                                  backgroundColor: 'rgba(233,78,26,0.07)',
                                                  '& .MuiChip-label': {
                                                    px: .8,
                                                    fontSize: '.66rem',
                                                    fontWeight: 700,
                                                  },
                                                }}
                                              />
                                            ))}
                                          </Box>
                                        )}
                                      </Box>
                                    </Tooltip>
                                  );
                                })}
                              </Box>
                            </Box>
                          ))}
                        </Stack>
                      </Box>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          </Box>
        </Grid>

        {/* PANEL DERECHO: DETALLE DEL CENTRO */}
        <Grid item xs={12} lg={4}>
          <Box
            sx={{
              ...glassCard,
              p: 2,
              minHeight: '52vh',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            {!centroActivo ? (
              <Box
                sx={{
                  height: '100%',
                  minHeight: '48vh',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  px: 2,
                }}
              >
                <Box>
                  <BusinessIcon sx={{ fontSize: '2.2rem', color: '#e94e1a', opacity: .8, mb: 1 }} />
                  <Typography sx={{ ...sectionTitle, fontSize: '1.1rem' }}>
                    Sin centro seleccionado
                  </Typography>
                  <Typography sx={{ ...infoText, mt: .8 }}>
                    Elige un centro del panel izquierdo para ver su información detallada.
                  </Typography>
                </Box>
              </Box>
            ) : (
              <>
                <Box>
                  <Typography sx={sectionLabel}>Detalle operativo</Typography>
                  <Typography sx={{ ...sectionTitle, fontSize: '1.35rem', mt: .3 }}>
                    {labelId(centroActivo.centro_id, 'car', capitalize(centroActivo.nombreCentro))}
                  </Typography>
                  {localStorage.getItem("cargo") === "Superusuario" && <Typography variant="caption" color="text.secondary">{centroActivo.centro_id}</Typography>}

                  <Box sx={{ display: 'flex', gap: .8, flexWrap: 'wrap', mt: 1.4 }}>
                    <Chip
                      icon={<PlaceIcon sx={{ fontSize: '1rem !important' }} />}
                      label={labelRegion(centroActivo.centro_id?.split('-')[2], capitalize(centroActivo.centro_id?.split('-')[2] || '--'))}
                      sx={{
                        color: '#d9e2ec',
                        backgroundColor: 'rgba(255,255,255,0.04)',
                        border: '1px solid rgba(233,78,26,0.18)',
                      }}
                    />
                    <Chip
                      icon={<SettingsInputAntennaIcon sx={{ fontSize: '1rem !important' }} />}
                      label={`GPS ${centroCoords.mode}`}
                      sx={{
                        color: '#d9e2ec',
                        backgroundColor: 'rgba(255,255,255,0.04)',
                        border: '1px solid rgba(233,78,26,0.18)',
                      }}
                    />
                  </Box>

                  <Divider sx={{ my: 2, borderColor: 'rgba(233,78,26,0.12)' }} />

                  <Stack spacing={1.4}>
                    <Box>
                      <Typography sx={sectionLabel}>Ubicación</Typography>
                      <Typography sx={infoText}>
                        Región: {labelRegion(centroActivo.centro_id?.split('-')[2], capitalize(centroActivo.centro_id?.split('-')[2] || '--'))}
                      </Typography>
                      <Typography sx={infoText}>
                        Área: {labelId(centroActivo.centro_id?.split('-').slice(1).reverse().join('-'), 'ra', capitalize(centroActivo.centro_id?.split('-')[1] || '--'))}
                      </Typography>
                      <Typography sx={infoText}>
                        Especie: {centroActivo.cicle_info?.specie || '--'}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography sx={sectionLabel}>Coordenadas</Typography>
                      <Typography sx={infoText}>Latitud: {centroCoords.lat}</Typography>
                      <Typography sx={infoText}>Longitud: {centroCoords.lon}</Typography>
                    </Box>

                    <Box>
                      <Typography sx={sectionLabel}>Rango de servicio</Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: .8, mt: .3 }}>
                        <CalendarMonthIcon sx={{ color: '#e94e1a', fontSize: '1.1rem' }} />
                        <Box>
                          <Typography sx={infoText}>
                            {translate('inicio')}: {centroDates.inicio}
                          </Typography>
                          <Typography sx={infoText}>
                            {translate('fin')}: {centroDates.fin}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    <Box>
                      <Typography sx={sectionLabel}>Servicios activos</Typography>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: .8, mt: .8 }}>
                        {serviciosActivos.length > 0 ? (
                          serviciosActivos.map(servicio => (
                            <Chip
                              key={servicio.key}
                              label={servicio.label}
                              sx={{
                                color: '#ffb08f',
                                backgroundColor: 'rgba(233,78,26,0.08)',
                                border: '1px solid rgba(233,78,26,0.25)',
                                fontWeight: 700,
                              }}
                            />
                          ))
                        ) : (
                          <Typography sx={infoText}>Sin servicios activos</Typography>
                        )}
                      </Box>
                    </Box>
                  </Stack>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    gap: 1,
                    mt: 3,
                  }}
                >
                  <Button
                    fullWidth
                    variant="outlined"
                    startIcon={editar ? <EditOffIcon /> : <EditIcon />}
                    onClick={() => (editar ? cancelEdit?.() : handleEdit(centroActivo))}
                    sx={{
                      borderColor: 'rgba(233,78,26,0.45)',
                      color: '#f4f6fb',
                      borderRadius: '14px',
                      py: 1,
                      textTransform: 'none',
                      fontWeight: 700,
                      '&:hover': {
                        borderColor: '#e94e1a',
                        backgroundColor: 'rgba(233,78,26,0.06)',
                      },
                    }}
                  >
                    {editar ? 'Cancelar edición' : 'Editar centro'}
                  </Button>

                  <Button
                    fullWidth
                    variant="contained"
                    startIcon={<DeleteIcon />}
                    onClick={handleOpenModal}
                    sx={{
                      borderRadius: '14px',
                      py: 1,
                      textTransform: 'none',
                      fontWeight: 700,
                      background: 'linear-gradient(90deg, #e94e1a, #ff6b2c)',
                      boxShadow: '0 0 16px rgba(233,78,26,0.22)',
                      '&:hover': {
                        background: 'linear-gradient(90deg, #d94715, #f86122)',
                      },
                    }}
                  >
                    Eliminar
                  </Button>
                </Box>
              </>
            )}
          </Box>
        </Grid>
      </Grid>

      {/* MODAL */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            ...glassCard,
            width: { xs: '88vw', sm: '420px' },
            p: 3,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            outline: 'none',
            background: 'linear-gradient(180deg, rgba(15,20,32,0.98), rgba(17,10,24,0.96))',
          }}
        >
          <Typography
            sx={{
              color: '#fff',
              fontSize: '1.1rem',
              fontWeight: 700,
              mb: 1,
            }}
          >
            {translate('confirm_delete_center')}
          </Typography>

          <Typography
            sx={{
              color: '#9eabba',
              fontSize: '.92rem',
              mb: 2.5,
            }}
          >
            Esta acción eliminará el registro seleccionado de forma permanente.
          </Typography>

          <Box sx={{ display: 'flex', gap: 1.2, justifyContent: 'flex-end' }}>
            <Button
              variant="outlined"
              onClick={handleCloseModal}
              sx={{
                borderColor: 'rgba(233,78,26,0.35)',
                color: '#dce3ec',
                borderRadius: '12px',
                textTransform: 'none',
                fontWeight: 700,
                px: 2,
                '&:hover': {
                  borderColor: '#e94e1a',
                  backgroundColor: 'rgba(233,78,26,0.05)',
                },
              }}
            >
              {translate('no')}
            </Button>

            <Button
              variant="contained"
              onClick={handleDelete}
              sx={{
                borderRadius: '12px',
                textTransform: 'none',
                fontWeight: 700,
                px: 2,
                background: 'linear-gradient(90deg, #e94e1a, #ff6b2c)',
                '&:hover': {
                  background: 'linear-gradient(90deg, #d94715, #f86122)',
                },
              }}
            >
              {translate('si')}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default Centro;
